export default __webpack_public_path__ + "static/media/logomini.ca0f9796.svg";